var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "16.5805mm",
    height: "14.1111mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 249 212",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_x0020_-_x0020_Filter"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "193,122 177,122 177,106 193,106 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M19 170c0,6 -4,10 -9,10 -6,0 -10,-4 -10,-10 0,-5 4,-9 10,-9 5,0 9,4 9,9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M36 106c0,5 -4,9 -10,9 -5,0 -9,-4 -9,-9 0,-5 4,-10 9,-10 6,0 10,5 10,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M69 66c0,5 -4,8 -8,8 -5,0 -8,-3 -8,-8 0,-4 3,-8 8,-8 4,0 8,4 8,8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M69 141c0,4 -4,8 -9,8 -4,0 -8,-4 -8,-8 0,-5 4,-9 8,-9 5,0 9,4 9,9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M26 41c0,6 -4,10 -9,10 -5,0 -10,-4 -10,-10 0,-5 5,-9 10,-9 5,0 9,4 9,9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#28AAE1",
    points: "201,106 201,53 225,79 249,106 225,132 201,159 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#28AAE1",
    points: "206,127 148,127 148,85 206,85 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "111,180 95,180 95,164 111,164 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "138,180 122,180 122,164 138,164 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "206,212 79,212 79,190 206,190 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "206,21 79,21 79,0 206,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "111,48 95,48 95,32 111,32 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "138,48 122,48 122,32 138,32 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "164,48 148,48 148,32 164,32 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "190,48 175,48 175,32 190,32 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "111,74 95,74 95,58 111,58 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "138,74 122,74 122,58 138,58 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "138,101 122,101 122,85 138,85 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "164,74 148,74 148,58 164,58 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "190,74 175,74 175,58 190,58 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "111,101 95,101 95,85 111,85 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "111,127 95,127 95,111 111,111 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "138,127 122,127 122,111 138,111 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "111,153 95,153 95,138 111,138 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "164,180 148,180 148,164 164,164 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "190,180 175,180 175,164 190,164 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "138,153 122,153 122,138 138,138 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "164,153 148,153 148,138 164,138 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "190,153 175,153 175,138 190,138 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.6ebf8c4d0d27711db9329cdb84e176f9.svg";
export { ForwardRef as ReactComponent };